export default "__VITE_ASSET__DS9xQ_Uc__"